import React, { Component } from 'react';
import { BsyUtils } from '../../../utils/Utils';
import BsySearchInput from "../../BsySearchInput";
import BsySearchResult from "../../BsySearchResult";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import './index.css';

import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

const DragHandle = sortableHandle(() => <i className="icon-drag" />);

const SortableItem = sortableElement((props) => (
    <>{props.children}</>
));

const SortableContainer = sortableContainer(({ children }) => {
    return <div className={'custom-app'}>{children}</div>;
});
class BsyDashboardCustomAppConfig extends Component {
    constructor(props) {
        console.log(1111)
        super(props)
        let ars = [];
        if (props.customApp.apps) {
            BsyUtils.forEach(props.customApp.apps, (key, res) => {
                ars.push(res)
            })
        }
        this.state = {
            apps: [],
            appMaps: {},
            customApps: ars,
            maxEntrys: 12,
            key: '',
            seachList: [],
        }

    }

    getAppList = () => {
        React.axios('/dashboard/app_group/list').then(res => {

            if (res.data.code === 0) {

                this.setState({
                    apps: [...res.data.items],
                }, () => {
                    // this.onSelectApp(this.state.appid);
                })
            } else {
                BsyUtils.showAjaxTip(res.data, () => {
                    this.setState({
                        apps: [...res.data.items],
                    }, () => {
                        // this.onSelectApp(this.state.appid);
                    })
                })
            }
        }).catch(res => {

        })
    }
    componentDidMount() {
        this.getAppList();
        this.getValue();
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const items = { ...nextProps.customApp }
        this.setState({
            customApp: items
        })
    }

    entryClick = (e) => {
        e.stopPropagation();
    }

    onSelectApp = (app, e, t) => {
        let { customApps } = this.state;
        if (!app) {
            return;
        }
        let customAppsList = [];
        customApps.map((appdata) => {
            customAppsList.push(appdata._id)
        })
        if (customAppsList.indexOf(app._id) < 0) {
            customApps.push(app);
            if (t === 'search') {
                let i = document.createElement("i");
                i.classList.add("icon-ok");
                e.currentTarget.appendChild(i)
            }
        }
        this.setState({
            customApps
        })
    }


    getSearchValue = (ref) => {
        this.searchValue = ref
    }

    onSearch = () => {

        let key = this.searchValue.getValue();
        if (!key) {
            this.setState({
                key: "",
                seachList: [],
            })
            return
        }
        React.axios('/dashboard/search', {
            keyword: key,
            type: "entry",
            range: 'noStandard'
        }).then(res => {
            this.setState({
                key: this.searchValue.getValue(),
                seachList: res.data.list,
            })
        }).catch(res => {
            console.error(res);
        })


    }
    findEntryS = (entry) => {
        const { customApps } = this.state;

        const s = customApps.filter((data, index) => {

            return data._id === entry._id
        })
        return s.length > 0;
    }
    entryDel = (entry) => {
        const { customApps } = this.state;
        const s = customApps.filter((data, index) => {
            return data._id !== entry._id
        })

        this.setState({
            customApps: s,
        }, () => {
            this.getValue(s);
        })
    }

    getValue = () => {
        const { customApps } = this.state;
        if (this.props.getValue) {
            this.props.getValue({ apps: customApps })
        }
    }

    entryAdd = (entry) => {
        const { customApps, maxEntrys } = this.state;

        const s = [...customApps, entry]
        this.setState({
            customApps: s,
        }, () => {
            this.getValue(s);
        })
    }

    entryAdd1 = (entry) => {
        return (event) => {
            const { customApps, maxEntrys } = this.state;

            const s = [...customApps, entry]
            this.setState({
                customApps: s,
            }, () => {
                this.getValue(s);
                let span = document.createElement("span");
                span.classList.add("read-tip");
                span.innerText = React.language('add.already');
                event.target.parentNode.appendChild(span);
                event.target.remove();
            })
        }
    }

    renderApplist = () => {
        const { apps, customApps } = this.state;
        let that = this;
        let customAppsList = [];
        customApps.map((appdata) => {
            customAppsList.push(appdata._id)
        })
        return <>
            {
                apps.map((data, index) => {
                    return <>
                        <div className={"applist-group"} title={data.name} >
                            {data.name}
                        </div>
                        {
                            data.apps.map((appdata, appindex) => {
                                return <div className={"applist-item "} >
                                    <div className='app-title' onClick={e => { that.onSelectApp(appdata, e) }}  >
                                        <div className={"app-icon color-cover-" + appdata.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + appdata.style.icon} /></div>
                                        <span className="appname" title={appdata.appname}>{appdata.appname}</span>
                                        {
                                            customAppsList.indexOf(appdata._id) > -1 && <i className="icon-ok" />
                                        }
                                    </div>
                                </div>
                            })
                        }
                    </>

                })
            }
        </>
    }

    onSortEnd = (data, groupInfo) => {
        const { oldIndex, newIndex } = data;
        const { customApps } = this.state;
        const scr = arrayMoveImmutable(customApps, oldIndex, newIndex);

        this.setState({
            customApps: scr
        }, () => {
            this.getValue(scr);
        })

    };

    renderSeachlist = () => {
        const { seachList } = this.state;

        return <div className='applist-item '>
            <div className='app-entrys' >
                {
                    seachList.map((data, index) => {
                        return <div className={'entry-item'} onClick={this.EntryClick} >
                            <i className={'entry-icon ' + BsyUtils.getFormIcon(data)} />
                            <span className={'entry-title'}>{data.name}</span>

                            <span className={'right-entry-title'}>{
                                this.findEntryS(data)
                                    ? <span className='read-tip'>{React.language('add.already')}</span>
                                    : <i className='icon-bsy-appAdd' onClick={e => { this.entryAdd(data) }} />
                            }</span>
                        </div>
                    })
                }
            </div>
        </div>
    }

    render() {
        const { customApps, maxEntrys, key, entryList } = this.state;
        let customAppsList = [];
        customApps.map((appdata) => {
            customAppsList.push(appdata._id)
        })
        return (
            <div className="dashboard-custom-app-config">
                <div className={"left-app-list"}>
                    <div className='applist-seach'>
                        <BsySearchResult
                            placeholder={React.language('form.search.placeholder')}
                            width={320}
                            height={350}
                            dockPosition="left"
                            async={{
                                url: '/dashboard/search',
                                data: {
                                    type: 'app',
                                    range: 'noStandard'
                                },
                                sucess: (items) => {
                                    return items.list
                                }
                            }}
                            onCreatResult={(res) => {
                                let appItem = [];
                                if (res && res.length > 0) {
                                    res.map((val) => {
                                        if (val.type === "app") {
                                            appItem.push(val)
                                        }
                                    })
                                }
                                return res && res.length > 0 ? <div className="searchAllAppFormReport">
                                    <ul className="searchApp">
                                        {
                                            appItem.length > 0 ? appItem.map((val) => {
                                                return val && <li key={val._id} onClick={e => { this.onSelectApp(val, e, 'search') }}>
                                                    <div className={"app-icon color-cover-" + val.style.color}>
                                                        <div className={"imgbg-small-bsy-app imgbg-bsy-app-" + val.style.icon} />
                                                    </div>
                                                    <span dangerouslySetInnerHTML={{ __html: val.titleHtml }} />
                                                    {
                                                        customAppsList.indexOf(val._id) > -1 && <i className="icon-ok" />
                                                    }
                                                </li>
                                            }) : <li className="emptySearchForm">
                                                {React.language('app.all.empty')}
                                            </li>
                                        }
                                    </ul>
                                </div> : <div className="emptySearchAll">
                                    {React.language('field.location.empty')}
                                </div>
                            }}
                            getValue={this.getSearchValue}
                            onSearch={this.onSearch}
                            type={window.mode}
                            // iconName="icon-bsy-reportmenu-0"
                        />
                    </div>
                    <div className='applist'>
                        {
                            !key ? this.renderApplist() : this.renderSeachlist()
                        }
                    </div>
                </div>
                <div className={"right-custom-app"}>
                    <div className='entrys-num'>
                        <span >
                            {
                                React.language("add.already.num", {
                                    num: customApps.length
                                })
                            }
                        </span>
                    </div>
                    {/* <div className='speedy-entrys'> */}
                    <SortableContainer
                        axis={'xy'}
                        distance={10}
                        useDragHandle={true}
                        onSortEnd={e => { this.onSortEnd(e) }}>
                        {

                            customApps.map((data, index) => {
                                return <SortableItem key={`item-${index}`} index={index} value={data} >
                                    <div className={'applist-item applistDrag'} onClick={this.EntryClick} >

                                        <div className="app-title">
                                            <div className={"app-icon color-cover-" + data.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon} /></div>
                                            <span className="appname">{data.appname}</span>
                                            <div className="entry-btn">
                                                <span className={'entry-del'} onClick={e => { this.entryDel(data) }} ><i className='icon-remove' /></span>
                                                <span className={'entry-move'}>
                                                    {
                                                        <DragHandle />
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </SortableItem>
                            })
                        }
                    </SortableContainer>
                    {/* </div> */}
                </div>
            </div>
        );
    }
}

export default BsyDashboardCustomAppConfig;
